/**
 * This file defines the root module of the Angular 2 of the application.
 */
// import angular2
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule} from "@angular/core";

import {RouterModule, UrlHandlingStrategy} from "@angular/router";
import {BrowserModule} from "@angular/platform-browser";
import {UpgradeModule} from "@angular/upgrade/static";
import {Http, HttpModule} from "@angular/http";
import {FormsModule} from "@angular/forms";
import {APP_BASE_HREF, CommonModule, Location, LocationStrategy} from "@angular/common";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {CoreModule} from "./core/core.module";
import {LoadingWheelComponent} from "./root/loading/loading-wheel.component";
import {InformationModalComponent} from "./root/information-modal/information-modal.component";
import {ModalComponent} from "./root/modal/modal.component";
import {ToastComponent} from "./root/toast/toast.component";
import {HeaderComponent} from "./root/sara-header/sara-header.component";
import "rxjs/add/operator/filter";
import {FeatureModule} from "./feature/feature.module";
import {SharedModule} from "./shared/shared.module";
import {NotificationsComponent} from "./root/sara-header/header-menu/notifications/notifications.component";
import {CookieModule} from "ngx-cookie";
import {AngularErrorHandler} from "./core/angular-error-handler";
import {RootCmp} from "./root.component";
import {CustomLocationStrategy, Ng1Ng2UrlHandlingStrategy} from "./url-handling-strategy";
import {WindowRef} from "./core/window-ref";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http, './assets/messages_', '.json?version=' + version);
}

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        UpgradeModule,
        FormsModule,
        HttpModule,
        FeatureModule,
        CoreModule,
        SharedModule,
        CookieModule.forRoot(),
        RouterModule.forRoot([]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [Http]
            }
        })
    ],
    providers: [
        {provide: APP_BASE_HREF, useValue: '/cars-sara-v2/web/'},
        {provide: LocationStrategy, useClass: CustomLocationStrategy},
        {provide: UrlHandlingStrategy, useClass: Ng1Ng2UrlHandlingStrategy}, Location, WindowRef,
        {provide: ErrorHandler, useClass: AngularErrorHandler}
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    bootstrap: [RootCmp],
    declarations: [
        RootCmp,
        LoadingWheelComponent,
        InformationModalComponent,
        ModalComponent,
        ToastComponent,
        HeaderComponent,
        NotificationsComponent
    ]
})
export class SaraV2AppModule {
    constructor(public upgrade: UpgradeModule) {
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/saraV2_app.ts